import loglevel from "loglevel";
// Customize this function to format the log messages
function formatLogMessage(level, message) {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] [${level.toUpperCase()}] protico-auth-logger: ${message}`;
}
// Create a custom logger that formats the log messages
class CustomLogger {
    constructor(loggerName) {
        this.logger = loglevel.getLogger(loggerName);
    }
    enableAll() {
        this.logger.setLevel(loglevel.levels.TRACE);
    }
    disableAll() {
        this.logger.setLevel(loglevel.levels.SILENT);
    }
    trace(message) {
        this.logger.trace(formatLogMessage("trace", message));
    }
    debug(message) {
        //remove debug logs
        // this.logger.debug(formatLogMessage("debug", message));
    }
    info(message) {
        this.logger.info(formatLogMessage("info", message));
    }
    warn(message) {
        this.logger.warn(formatLogMessage("warn", message));
    }
    error(message) {
        this.logger.error(formatLogMessage("error", message));
    }
}
export default new CustomLogger("protico-auth-logger");
//# sourceMappingURL=loglevel.js.map